import "./ajax/events";
import "./ajax/forumFilters";
import "./custom/gforms";
import "./custom/wizard";
import "./custom/password-strength";
import "./ajax/load_more";
import "./ajax/like-function";
// import "./custom/sort-threaded-replies";
// import "./custom/refresh-after-submission";
// import "./custom/2fa-popup";
import Dropzone from "dropzone";
